import { Box, Button, Flex, type ResponsiveValue, SimpleGrid, Text } from '@chakra-ui/react'

import SeriesQ from '@/queries/SeriesQ'
import type { Query } from '@/client/query'

import { QUERY_LIMIT_MAX } from '@/components/Session/helpers'

import SeriesBoxFromQuery from './SeriesBox/SeriesBoxFromQuery'

const SeriesList: React.FC<{
  series: Query[]
  totalItemsCount: number
  limit?: number
  onLoadMore?: () => void
  noMaxLearners?: boolean
  grayIfFull?: boolean
  hideHeader?: boolean
  emptyMessage?: string
  columns?: ResponsiveValue<number>
  openLinksInNewTab?: boolean
  disableWithTooltip?: string
}> = ({
  series,
  totalItemsCount,
  limit,
  onLoadMore,
  noMaxLearners = false,
  grayIfFull = false,
  hideHeader = false,
  emptyMessage = 'There are currently no series matching this criteria.',
  columns = [1, 2],
  openLinksInNewTab = false,
  disableWithTooltip,
}) => (
  <Box mb="32px" justifyContent="left">
    {hideHeader ? null : (
      <Text color="fg.muted" mt="40px" mb="16px" fontWeight={600}>
        {totalItemsCount} Series
      </Text>
    )}
    {series.length > 0 ? (
      <SimpleGrid columns={columns} spacingX="24px" spacingY="24px">
        {series.map(seriesItem => (
          <SeriesBoxFromQuery
            key={seriesItem(SeriesQ.id) ?? 0}
            series={seriesItem}
            noMaxLearners={noMaxLearners}
            grayIfFull={grayIfFull}
            disableWithTooltip={disableWithTooltip}
            openLinksInNewTab={openLinksInNewTab}
            hideSeriesHeader
          />
        ))}
      </SimpleGrid>
    ) : null}
    {totalItemsCount === 0 ? <Text>{emptyMessage}</Text> : null}
    {totalItemsCount > 0 && limit != null && onLoadMore != null ? (
      <Flex justifyContent="center" mt={6}>
        {totalItemsCount > limit && limit < QUERY_LIMIT_MAX ? (
          <Button variant="outline" minWidth="150px" onClick={onLoadMore}>
            See More
          </Button>
        ) : null}
      </Flex>
    ) : null}
  </Box>
)

export default SeriesList
